import React from "react";
import RoleSymbol from "../../../RoleSymbol";

const RoleListCell = (cellData) => {
  let list = cellData.data[cellData.column.dataField];
  return (
    <div>
      {(list && list.length > 0)
        ? list.map(({ symbol, name }) =><RoleSymbol symbol={symbol} title={name}/>)
        : "Не указаны"}
    </div>);
};

function calculateString(list, sep = "") {
  let str = "";
  if (list && list.length > 0) {
    list.map(({name}, idx) => {
      str = str + name;
      if (idx < list.length - 1) {
        str += sep + " "
      }
    })
  }
  return str;
}

function roleListCell(config, columnSpec) {
  let field = columnSpec.dataField;
  config.cellRender = RoleListCell;
  config.dataType = "string";
  config.calculateCellValue = (row) => {
    if (row[field]) {
      return calculateString(row[field]);
    } else {
      return null;
    }
  }
}

export {roleListCell}
